import React from "react";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    selectHasUnsavedChanges,
    selectUpdateStatus,
    updateToolSettings,
    resetToolSettings
} from "./toolSettingsSlice";
import {ToolSettingsForm} from "./ToolSettingsForm";
import {showErrorToastNotification, showSuccessToastNotification} from "../../../../elements/toastNotification/toastNotificationSlice";
import {FullBotUi} from "../../../../../api/generated";
import {fetchBotById} from "../../botSlice";
import {useUnsavedChangesWarning} from "../../../../../hooks/useUnsavedChangesWarning";

interface ToolSettingsTabProps {
    bot: FullBotUi;
}

export const ToolSettingsTab: React.FC<ToolSettingsTabProps> = ({bot}) => {
    const dispatch = useAppDispatch();
    const hasUnsavedChanges = useAppSelector(selectHasUnsavedChanges);
    const updateStatus = useAppSelector(selectUpdateStatus);

    useUnsavedChangesWarning(hasUnsavedChanges);

    const handleSave = async () => {
        try {
            await dispatch(updateToolSettings(bot.publicId)).unwrap();
            dispatch(showSuccessToastNotification({message: "Tool settings updated successfully"}));
            dispatch(fetchBotById(bot.publicId));
        } catch (error) {
            dispatch(showErrorToastNotification({message: "Failed to update tool settings"}));
        }
    };

    const handleDiscard = () => {
        dispatch(resetToolSettings());
    };

    return <ToolSettingsForm
        hasUnsavedChanges={hasUnsavedChanges}
        onSave={handleSave}
        onDiscard={handleDiscard}
        botType={bot.botType}
        updateStatus={updateStatus}
    />;
};
